if (!customElements.get('cart-drawer-cross-sells')) {
  class CartDrawerCrossSells extends HTMLElement {
    constructor() {
      super();

      this.handleClick = this.handleClick.bind(this);
    }

    connectedCallback() {
      this.addEventListener('click', this.handleClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
    }

    async handleClick(event) {
      const button = event.target.closest('[data-cross-sell-add]');

      if (!button || !this.contains(button) || button.disabled) {
        return;
      }

      const variantId = button.dataset.variantId;
      const card = button.closest('.cart-cross-sell');
      const label = button.querySelector('[data-cross-sell-label]');
      const errorElement = card?.querySelector('[data-cross-sell-error]');
      const cartDrawer = document.querySelector('cart-drawer');

      if (!variantId) {
        return;
      }

      button.disabled = true;
      button.classList.add('is-loading');

      if (label) {
        label.textContent = 'Adding';
      }

      if (errorElement) {
        errorElement.textContent = '';
      }

      try {
        const sections =
          typeof cartDrawer?.getSectionsToRender === 'function'
            ? cartDrawer
                .getSectionsToRender()
                .map((section) => section.id)
            : ['cart-drawer', 'cart-icon-bubble'];

        const response = await fetch(
          `${window.Shopify.routes.root}cart/add.js`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({
              id: Number(variantId),
              quantity: 1,
              sections,
              sections_url: window.location.pathname
            })
          }
        );

        const parsedState = await response.json();

        if (!response.ok || parsedState.status) {
          throw new Error(
            parsedState.description ||
              parsedState.message ||
              'The product could not be added.'
          );
        }

        if (
          cartDrawer &&
          typeof cartDrawer.renderContents === 'function'
        ) {
          cartDrawer.renderContents(parsedState);
        } else {
          window.location.href = `${window.Shopify.routes.root}cart`;
        }
      } catch (error) {
        button.disabled = false;
        button.classList.remove('is-loading');

        if (label) {
          label.textContent = 'Add';
        }

        if (errorElement) {
          errorElement.textContent =
            error.message || 'Something went wrong.';
        }

        console.error(error);
      }
    }
  }

  customElements.define(
    'cart-drawer-cross-sells',
    CartDrawerCrossSells
  );
}